export enum RiskCategoryEnum {
    noRisk = 1,
    highRisk = 2,
}